/************** Footer Newsletter *******************/
$(document).on('change', '#agree', function () {
  if (this.checked) {
    $(this).next('.check_tooltip').css('display', 'none');
  } else {
    $(this).next('.check_tooltip').css('display', 'block');
  }
});
$(document).on('click', '#newsletter__submit_btn', function () {
  if ($('#agree').is(':checked')) {
    $('#agree').removeClass('not-selected');
    $('#agree').next('.check_tooltip').css('display', 'none');
    
  } else {
    $('#agree').addClass('not-selected');
    setTimeout(function () {
      $('#agree').next('.check_tooltip').css('display', 'block');
    }, 100);
    return false;
  }
  if ($('#birthday_inp').val() !== '') {
    console.log($('#birthday_inp').val())
    $('#birthday_inp').parent().removeClass('empty');
    
  } else {
    $('#birthday_inp').parent().addClass('empty');
    return false;
  }
  if($('#agree').is(':checked') && $('#birthday_inp').val() !== ''){
    $(this).submit();
  }
});

/************** Cart Page *******************/
$(document).on('change', '#cart_agree', function () {
  if (this.checked) {
    $(this).next('.check_tooltip').css('display', 'none');
  } else {
    $(this).next('.check_tooltip').css('display', 'block');
  }
});
// $(document).on('click', '#cart__submit_btn', function () {
//   if ($('#cart_agree').is(':checked')) {
//     $('#cart_agree').removeClass('not-selected');
//     $('#cart_agree').next('.check_tooltip').css('display', 'none');
//     $(this).addClass('btn--loading');
//     $(this).submit();
//   } else {
//     $('#cart_agree').addClass('not-selected');
//     $('#cart_agree').next('.check_tooltip').css('display', 'block');
//     setTimeout(function () {
//       $('#cart_agree').next('.check_tooltip').css('display', 'block');
//     }, 100);
//     return false;
//   }
// });

/************** Side Cartx Page *******************/
$(document).on('click', '.cart_drawer_tooltip', function () {
  console.log('clicked');
  console.log($(document).find('.cart_drawer_tip'));
  $(document).find('.cart_drawer_tip').checked = true;
});
$(document).on('change', '.cart_drawer_tip', function () {
  if (this.checked) {
    $(this).next('.check_tooltip2').css('display', 'none');
  }
});

// $(document).on("click","#sidecart__submit_btn", function(){

//   //e.preventDefault();
//   console.log($(document).find('.cart_drawer_tip').next('.check_tooltip2'))
//   if($("body .cart_drawer_tip").is(':checked')) {
//     $(document).find('.cart_drawer_tip').removeClass('not-selected');
//     $(document).find('.cart_drawer_tip').next('.check_tooltip2').css('display','none');
//     $(this).addClass('btn--loading');
//     $(this).submit();
//   }else {
//     $(document).find('.cart_drawer_tip').addClass('not-selected');
//     $(document).find('.cart_drawer_tip').next('.check_tooltip2').css('display','block');
//     return false;
//   }

// });

/************** Contact Page *******************/
$(document).on('change', '#contact_agree', function () {
  if (this.checked) {
    $(this).next('.check_tooltip').css('display', 'none');
  } else {
    $(this).next('.check_tooltip').css('display', 'block');
  }
});
$(document).on('click', '#contact__submit_btn', function () {
  if ($('#contact_agree').is(':checked')) {
    $('#contact_agree').removeClass('not-selected');
    $('#contact_agree').next('.check_tooltip').css('display', 'none');
    $(this).submit();
  } else {
    $('#contact_agree').addClass('not-selected');
    setTimeout(function () {
      $('#contact_agree').next('.check_tooltip').css('display', 'block');
    }, 100);
    return false;
  }
});

/************** Register Page *******************/
$(document).on('change', '#register_agree', function () {
  if (this.checked) {
    $(this).next('.check_tooltip').css('display', 'none');
  } else {
    $(this).next('.check_tooltip').css('display', 'block');
  }
});

$(document).on('click', '#register__submit_btn', function () {
  if ($('#register_agree').is(':checked')) {
    $('#register_agree').removeClass('not-selected');
    $('#register_agree').next('.check_tooltip').css('display', 'none');
    $(this).submit();
  } else {
    $('#register_agree').addClass('not-selected');
    setTimeout(function () {
      $('#register_agree').next('.check_tooltip').css('display', 'block');
    }, 100);
    return false;
  }
});
